import React from 'react';
import { Box, Typography, Button, useTheme } from '@ublend-npm/aulaui-core';
import successBackgroundLight from '@static/create-assignment-success-light.svg';
import successBackgroundDark from '@static/create-assignment-success-dark.svg';

type AssignmentSuccessViewProps = {
  onViewAssignment: () => void;
  onClose: () => void;
  styles: Record<string, any>;
  title?: string;
  showViewAssignmentButton?: boolean;
};

const AssignmentSuccessView = ({
  onViewAssignment,
  onClose,
  styles,
  title = 'Excellent!',
  showViewAssignmentButton = true,
}: AssignmentSuccessViewProps) => {
  const theme = useTheme();

  const successBackground =
    theme.palette.mode === 'dark'
      ? successBackgroundDark
      : successBackgroundLight;

  return (
    <Box sx={styles.successContent}>
      <img
        src={successBackground as string}
        aria-hidden="true"
        alt=""
        style={{
          width: '138px',
          height: '172px',
        }}
      />

      <Typography sx={styles.successTitle}>{title}</Typography>

      <Box sx={styles.successFooter}>
        {showViewAssignmentButton ? (
          <Button
            kind="primary"
            onClick={onViewAssignment}
            aria-label="View Assignment"
            sx={styles.successButton}
          >
            View Assignment
          </Button>
        ) : (
          <Typography sx={styles.successSubtitle}>
            Your assignment has been saved.
          </Typography>
        )}

        <Typography
          onClick={onClose}
          role="button"
          tabIndex={0}
          aria-label="Close"
          data-testid="close-assignment-create-button"
          sx={styles.successCloseButton}
        >
          Close
        </Typography>
      </Box>
    </Box>
  );
};

export default AssignmentSuccessView;
